// Social link normalization (web mirror of app/services/socialLinks.js).
//
// Users only need to enter a username — we supply the platform base
// (e.g. "instagram.com/"). A pasted full URL or "@handle" is still accepted so
// existing entries keep working. `buildSocialUrl` runs both on save (store a
// canonical link) and on display, so it must be idempotent on its own output.

const BASES = {
  instagram: { host: 'instagram.com', path: '' },
  tiktok:    { host: 'tiktok.com',    path: '@' },
  facebook:  { host: 'facebook.com',  path: '' },
};

const SOCIAL_HOST_RE = /(instagram\.com|instagr\.am|tiktok\.com|facebook\.com|fb\.com|fb\.me)/i;

// Prefix shown before the input so people know they only need a username.
export const SOCIAL_PREFIX = {
  instagram: 'instagram.com/',
  tiktok:    'tiktok.com/@',
  facebook:  'facebook.com/',
};

// raw (username | @handle | "host/path" | full URL) -> canonical https URL | null
export function buildSocialUrl(platform, raw) {
  const v = String(raw || '').trim();
  if (!v) return null;
  if (/^https?:\/\//i.test(v)) return v;
  if (v.includes('/') || SOCIAL_HOST_RE.test(v)) return `https://${v.replace(/^\/+/, '')}`;
  const base = BASES[platform];
  if (!base) return `https://${v}`;
  const handle = v.replace(/^@+/, '').replace(/^\/+|\/+$/g, '');
  return handle ? `https://${base.host}/${base.path}${handle}` : null;
}

// Extract just the handle from whatever is stored, for pre-filling the input.
export function socialHandle(platform, raw) {
  let v = String(raw || '').trim();
  if (!v) return '';
  v = v.replace(/^https?:\/\//i, '').replace(/^www\./i, '');
  const base = BASES[platform];
  if (base) v = v.replace(new RegExp('^' + base.host.replace(/\./g, '\\.') + '/+@?', 'i'), '');
  return v.replace(/^@+/, '').split(/[/?#]/)[0].replace(/\/+$/g, '');
}
